var _a;
import { createActions } from 'redux-actions';
export var getInspiration = (_a = createActions('GET_INSPIRATION', 'GET_INSPIRATION_COMPLETE', 'GET_INTRO', 'GET_INTRO_COMPLETE'), _a.getInspiration), getInspirationComplete = _a.getInspirationComplete, getIntro = _a.getIntro, getIntroComplete = _a.getIntroComplete;
